import { useState } from "react";

function CourtAddress({ court }) {
  const [copied, setCopied] = useState(false);

  // Filters out falsy values and "N/A" entries
  const addressParts = [
    court.address.firstLine,
    court.address.secondLine,
    court.address.city,
    court.address.state,
    court.address.postcode,
    court.address.country,
  ].filter((part) => part && part.toUpperCase() !== "N/A");

  const formattedAddress = addressParts.join(", ");

  const handleCopy = () => {
    navigator.clipboard.writeText(formattedAddress).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <p>
      <strong>Location: </strong>
      <span
        onClick={handleCopy}
        style={{
          cursor: "pointer",
          textDecoration: "underline",
          color: "grey",
        }}
        title="Click to copy"
      >
        {formattedAddress}
        {copied && (
          <span style={{ marginLeft: "8px", color: "green", fontWeight: "bold" }}>
            ✔ Copied!
          </span>
        )}
      </span>
    </p>
  );
}

export default CourtAddress;